<template>
  <resumo-padrao ref="resumo" resumo-proposta></resumo-padrao>
</template>
<script>
export default {
  props: {
    value: null,
  },
  computed: {
    isentarIOF () {
      return this.$api.Estruturadas.isNotaComercial(this.value.TipoContratoSigla)
    }
  },
  methods: {
    load: async function () {
      const th = this
      if (th.value.TipoCalculoFluxo === th.$aux.TipoFluxoEnum.Irregular) {
        const { PMTIrregular: { Resumo } } = await th.$api.Estruturadas.CalcularFluxoIrregular(th, th.value.dtoFluxoIrregular)
        return th.setModel({ Proposta: Resumo })
      }
      const dto = {
        codigoProposta: th.value.Codigo,
        usarJurosProposta: true,
        calculoGradesParcelas: true,
        montaFluxoPagamentoEstatico: true,
      }
      th.$api.Multiplo.CalcularCamposProposta({ dto }).then(
        (result) => {
          th.setModel(result)
        }
      );
    },
    async setModel (result) {
      const th = this
      const IOF_NOTA = 0.001
      var proposta = {
        ...th.value,
        ...result.Proposta
      }
      if (th.isentarIOF && !Number.isInteger(result.Proposta.VlrTotalCredito)) {
        th.model = proposta
        await th.$api.Estruturadas.RoundNotaComercial(th)
        proposta.VlrTAC = th.model.VlrTAC
      }

      let valorTotalSolicitado = (proposta.VlrSolicitado || 0)
      if (proposta.TipoOperacaoCred === 3) { valorTotalSolicitado = (proposta.VlrProdutoBem || 0) - (proposta.VlrEntrada || 0) }
      valorTotalSolicitado += (proposta.VlrTAC || 0) + (proposta.VlrRegistro || 0)

      if (proposta.OutrosServicos) { valorTotalSolicitado += (proposta.VlrSeguro || 0) + (proposta.VlrAvaliacao || 0) + (proposta.VlrVistoria || 0) }

      const model = {
        Codigo: proposta.Codigo,
        Situacao: proposta.Situacao,
        SituacaoDescricao: proposta.SituacaoDescricao,
        CodigoCliente: proposta.CodigoCliente,

        Cliente: {
          ...proposta.Cliente,
        },

        TipoOperacaoCred: proposta.TipoOperacaoCred,
        TipoOperacaoNome: proposta.TipoOperacaoNome,
        TipoContratoDescricao: proposta.TipoContratoDescricao,
        TipoCalculoFluxo: th.value.TipoCalculoFluxo,
        PrimeiraParcela: result.Proposta.Parcelas[0],
        UltimaParcela: result.Proposta.Parcelas[result.Proposta.Parcelas.length - 1],
        Prazo: proposta.Prazo,

        VlrSolicitado: proposta.TipoOperacaoCred === 3 ? (proposta.VlrProdutoBem - proposta.VlrEntrada) : proposta.VlrSolicitado,
        VlrTAC: proposta.VlrTAC,
        VlrTotalSolicitado: valorTotalSolicitado,
        VlrIOF: th.isentarIOF ? IOF_NOTA : (proposta.VlrIOF || proposta.IOF),
        VlrTotalFinanciado: (proposta.VlrIOF || 0) + valorTotalSolicitado,
        VlrTotalDivida: proposta.VlrTotalDivida,

        OutrosServicos: proposta.OutrosServicos,
        VlrSeguro: proposta.VlrSeguro,
        VlrAvaliacao: proposta.VlrAvaliacao,
        VlrVistoria: proposta.VlrVistoria,
        VlrRegistro: proposta.VlrRegistro,

        PercIndiceFinan: proposta.PercIndiceFinan,
        PercJurosMensal: result.Proposta.PercJurosMensal || result.Proposta.TxJurosAoMes,
        PercJurosAnual: result.Proposta.PercJurosAnual || result.Proposta.TxJurosAoAno,
        PercCETMensal: result.Proposta.PercCETMensal || result.Proposta.CETaoMes,
        PercCETAnual: result.Proposta.PercCETAnual || result.Proposta.CETaoAno,
        ModeloCalculo: proposta.ModeloCalculo,
        TipoIndexador: proposta.TipoIndexador,
        TipoIndiceFinan: proposta.TipoIndiceFinan,

        Parcelas: proposta.Parcelas,
      }
      th.$refs.resumo.load(model)
    }
  }
}

</script>
